import { Navigate, Route, Routes } from "react-router-dom";
import DashLayout from "./components/DashLayout";
import AdminLayout from "./components/AdminLayout";
import ProtectedRoute from "./components/ProtectedRoute";
import { FiltersProvider } from "./lib/filters";
import AdminPage from "./pages/AdminPage";
import BranchesPage from "./pages/admin/BranchesPage";
import CompaniesPage from "./pages/admin/CompaniesPage";
import EmployeesPage from "./pages/admin/EmployeesPage";
import LocationsPage from "./pages/admin/LocationsPage";
import MappingsPage from "./pages/admin/MappingsPage";
import LoginPage from "./pages/LoginPage";
import ExecutivePage from "./pages/ExecutivePage";
import ExecutiveHomePage from "./pages/ExecutiveHomePage";
import DailyBriefingPage from "./pages/DailyBriefingPage";
import FailuresPage from "./pages/FailuresPage";
import SourceHealthPage from "./pages/SourceHealthPage";
import FinancePage from "./pages/FinancePage";
import StockPage from "./pages/StockPage";
import NeedsAttentionPage from "./pages/NeedsAttentionPage";
import LeaguesPage from "./pages/LeaguesPage";
import TrendsPage from "./pages/TrendsPage";
import HistoricalPerformancePage from "./pages/HistoricalPerformancePage";
import ComparisonPage from "./pages/ComparisonPage";
import ExecutiveReportsPage from "./pages/ExecutiveReportsPage";
import ExecutiveDigestPage from "./pages/ExecutiveDigestPage";
import RepairsPage from "./pages/RepairsPage";
import SupportPage from "./pages/SupportPage";
import SubscriptionsPage from "./pages/SubscriptionsPage";
import RotaPage from "./pages/RotaPage";
import PimPage from "./pages/PimPage";
import IntegrationsPage from "./pages/IntegrationsPage";
import CustomersPage from "./pages/CustomersPage";
import CustomerRankingsPage from "./pages/CustomerRankingsPage";
import RevenueConcentrationPage from "./pages/RevenueConcentrationPage";
import CustomerJourneyPage from "./pages/CustomerJourneyPage";
import DecisionCentrePage from "./pages/DecisionCentrePage";
import PrioritiesPage from "./pages/PrioritiesPage";
import WhatChangedPage from "./pages/WhatChangedPage";
import RiskRegisterPage from "./pages/RiskRegisterPage";
import ManagementActionsPage from "./pages/ManagementActionsPage";
import ReportingAdminPage from "./pages/admin/ReportingAdminPage";
import OutlookPage from "./pages/OutlookPage";
import TargetPacingPage from "./pages/TargetPacingPage";
import ForecastingV2Page from "./pages/ForecastingV2Page";
import ForecastAccuracyPage from "./pages/ForecastAccuracyPage";
import BoardPackPage from "./pages/BoardPackPage";
import TrustOverviewPage from "./pages/TrustOverviewPage";
import ConnectorFreshnessPage from "./pages/ConnectorFreshnessPage";
import ReconciliationCentrePage from "./pages/ReconciliationCentrePage";
import KpiQualityPage from "./pages/KpiQualityPage";
import BoardPackTrustPage from "./pages/BoardPackTrustPage";
import ReviewQueuePage from "./pages/ReviewQueuePage";
import EscalationsPage from "./pages/EscalationsPage";
import NotificationCentrePage from "./pages/NotificationCentrePage";
import RenewalsBillingPage from "./pages/RenewalsBillingPage";
import SupportOpsPage from "./pages/SupportOpsPage";
import RepairPipelinePage from "./pages/RepairPipelinePage";
import CatalogueHealthPage from "./pages/CatalogueHealthPage";
import WorkforceCapacityPage from "./pages/WorkforceCapacityPage";
import EcosystemCoveragePage from "./pages/EcosystemCoveragePage";
import AcceptanceCentrePage from "./pages/AcceptanceCentrePage";
import AccountabilityPage from "./pages/AccountabilityPage";
import ScenarioPlanningPage from "./pages/ScenarioPlanningPage";
import DecisionRecordsPage from "./pages/DecisionRecordsPage";
import DecisionPortfolioPage from "./pages/DecisionPortfolioPage";
import HistoricalDurabilityPage from "./pages/HistoricalDurabilityPage";
import ConnectorOperationsPage from "./pages/ConnectorOperationsPage";
import MetricCataloguePage from "./pages/MetricCataloguePage";
import OperationalReadinessPage from "./pages/OperationalReadinessPage";
import ValidationPage from "./pages/ValidationPage";
import VoiceCallsPage from "./pages/VoiceCallsPage";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<ProtectedRoute />}>
        <Route
          element={
            <FiltersProvider>
              <DashLayout />
            </FiltersProvider>
          }
        >
          <Route index element={<ExecutiveHomePage />} />
          <Route path="/overview" element={<ExecutivePage />} />
          <Route path="/briefing" element={<DailyBriefingPage />} />
          <Route path="/attention" element={<NeedsAttentionPage />} />
          <Route path="/leagues" element={<LeaguesPage />} />
          <Route path="/failures" element={<FailuresPage />} />
          <Route path="/health" element={<SourceHealthPage />} />
          <Route path="/finance" element={<FinancePage />} />
          <Route path="/stock" element={<StockPage />} />
          <Route path="/repairs" element={<RepairsPage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/subscriptions" element={<SubscriptionsPage />} />
          <Route path="/rota" element={<RotaPage />} />
          <Route path="/pim" element={<PimPage />} />
          <Route path="/trends" element={<TrendsPage />} />
          <Route path="/history" element={<HistoricalPerformancePage />} />
          <Route path="/compare/company" element={<ComparisonPage dim="company" />} />
          <Route path="/compare/branch" element={<ComparisonPage dim="branch" />} />
          <Route path="/reports" element={<ExecutiveReportsPage />} />
          <Route path="/digest" element={<ExecutiveDigestPage />} />
          <Route path="/integrations" element={<IntegrationsPage />} />
          <Route path="/customers" element={<CustomersPage />} />
          <Route path="/customers/rankings" element={<CustomerRankingsPage />} />
          <Route path="/customers/concentration" element={<RevenueConcentrationPage />} />
          <Route path="/customers/:id" element={<CustomerJourneyPage />} />
          <Route path="/decisions" element={<DecisionCentrePage />} />
          <Route path="/decisions/priorities" element={<PrioritiesPage />} />
          <Route path="/decisions/changes" element={<WhatChangedPage />} />
          <Route path="/decisions/risks" element={<RiskRegisterPage />} />
          <Route path="/decisions/actions" element={<ManagementActionsPage />} />
          <Route path="/escalations" element={<EscalationsPage />} />
          <Route path="/notifications" element={<NotificationCentrePage />} />
          <Route path="/payments/renewals" element={<RenewalsBillingPage />} />
          <Route path="/support/operations" element={<SupportOpsPage />} />
          <Route path="/repairs/pipeline" element={<RepairPipelinePage />} />
          <Route path="/pim/catalogue-health" element={<CatalogueHealthPage />} />
          <Route path="/workforce/capacity" element={<WorkforceCapacityPage />} />
          <Route path="/ecosystem" element={<EcosystemCoveragePage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
          <Route path="/outlook" element={<OutlookPage />} />
          <Route path="/pacing-targets" element={<TargetPacingPage />} />
          <Route path="/forecasting-v2" element={<ForecastingV2Page />} />
          <Route path="/forecast-accuracy" element={<ForecastAccuracyPage />} />
          <Route path="/board-pack" element={<BoardPackPage />} />
          <Route path="/trust" element={<TrustOverviewPage />} />
          <Route path="/trust/connectors" element={<ConnectorFreshnessPage />} />
          <Route path="/trust/reconciliation" element={<ReconciliationCentrePage />} />
          <Route path="/trust/kpis" element={<KpiQualityPage />} />
          <Route path="/trust/board-pack" element={<BoardPackTrustPage />} />
          <Route path="/trust/reviews" element={<ReviewQueuePage />} />
          <Route element={<ProtectedRoute requireRole="admin" />}>
            <Route path="/voice/calls" element={<VoiceCallsPage />} />
            <Route path="/accountability" element={<AccountabilityPage />} />
            <Route path="/scenarios" element={<ScenarioPlanningPage />} />
            <Route path="/decision-records" element={<DecisionRecordsPage />} />
            <Route path="/decision-portfolio" element={<DecisionPortfolioPage />} />
            <Route path="/connectors/operations" element={<ConnectorOperationsPage />} />
            <Route path="/metrics/catalogue" element={<MetricCataloguePage />} />
            <Route path="/operations/readiness" element={<OperationalReadinessPage />} />
            <Route path="/history/coverage" element={<HistoricalDurabilityPage />} />
            <Route path="/history/period-closes" element={<HistoricalDurabilityPage />} />
            <Route path="/acceptance" element={<AcceptanceCentrePage />} />
            <Route path="/validation/kpis" element={<ValidationPage />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminPage />} />
              <Route path="companies" element={<CompaniesPage />} />
              <Route path="branches" element={<BranchesPage />} />
              <Route path="locations" element={<LocationsPage />} />
              <Route path="employees" element={<EmployeesPage />} />
              <Route path="mappings" element={<MappingsPage />} />
              <Route path="reporting" element={<ReportingAdminPage />} />
            </Route>
          </Route>
        </Route>
      </Route>
    </Routes>
  );
}
